import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  createFolderType,
  useCreateFolderByTypologyAsync,
} from '@/features/easy/preFolderQualification/apis/useCreateFolderTypology';

export const useCreateFolderByTypology = () => {
  const navigate = useNavigate();
  const [hasErrorMessage, setHasErrorMessage] = useState(false);
  const { mutateAsync: createFolderTypology, isSuccess: isCreateFolderByTypologySuccess } =
    useCreateFolderByTypologyAsync();

  const handleCreateFolderTypology = ({ folderId, folderTypologyId }: createFolderType) => {
    createFolderTypology(
      {
        folderId,
        folderTypologyId,
      },
      {
        onSuccess: () => navigate(`/folders/${folderId}/customs-documents`),
        onError: () => setHasErrorMessage(true),
      },
    );
  };

  return {
    hasErrorMessage,
    isCreateFolderByTypologySuccess,
    handleCreateFolderTypology,
    setHasErrorMessage,
  };
};
